import type { USER_LEAD_CARRYING_ROLE } from 'cpool-constants';
import { USER_LEAD_CARRYING_ROLES } from 'cpool-constants';

export const isLeadCarryingRole = (role: unknown): role is USER_LEAD_CARRYING_ROLE =>
    USER_LEAD_CARRYING_ROLES.some((leadCarryingRole) => leadCarryingRole === role);
